export default __webpack_public_path__ + "static/1c003cc6-0f8f-4c82-adde-a5a026b56b50-1fa9a50e632cdcd87125e90f4a782af1.woff";